// project imports
import dashboard from './dashboard';
import clients from './clients';
import centres from './centres';
import brokers from './brokers';
import carriers from './carriers';
import payments from './payments';
import claims from './claims';
import reports from './reports';
import groupPlans from './group-plans';
import feeGuides from './fee-guides';
import members from './members';
import testTable from './test-table';
import serviceProviders from './service-providers';
import separator from './separator';
import users from './users';
import audit from './audit';
import emailsSent from './emails-sent';
import usePermissions from '../hooks/usePermissions';
import { isStatusDiscrepancyDevUser } from '../config/devOnlyRoutes';

// ==============================|| MENU ITEMS ||============================== //

// Base menu items with permission requirements
// Emergency Dentists and Specialists are now children of Service Providers
// Users menu is placed near the end of the navigation with a separator above it
// Audit is root-only, after users
// Emails Sent is Michael + AI only, last item
// Payees module removed Jul 2026 (historical capitation; last payment 2011) — see docs/PAYEES_MODULE_REMOVED.md
const baseMenuItems = [dashboard, clients, centres, brokers, carriers, groupPlans, feeGuides, members, claims, payments, reports, testTable, serviceProviders, separator, users, audit, emailsSent];

const isMenuItemVisible = (item, hasPermission, user) => {
  if (item.id === 'payments') {
    return true;
  }
  if (item.rootOnly) {
    return !!user?.root;
  }
  if (item.devOnly) {
    return isStatusDiscrepancyDevUser(user?.username);
  }
  if (item.permission) {
    return hasPermission(item.permission.module, item.permission.level);
  }
  return true;
};

const filterMenuTree = (items, hasPermission, user) => {
  return items
    .map((item) => {
      if (item.type === 'divider') {
        return item;
      }

      if (!isMenuItemVisible(item, hasPermission, user)) {
        return null;
      }

      if (item.children?.length) {
        const children = filterMenuTree(item.children, hasPermission, user);
        if (item.type === 'collapse' && children.length === 0) {
          return null;
        }
        return { ...item, children };
      }

      return item;
    })
    .filter(Boolean);
};

// Function to filter menu items based on permissions
const getFilteredMenuItems = (permissions, hasPermission, user) => {
  return filterMenuTree(baseMenuItems, hasPermission, user);
};

// Hook to get filtered menu items
export const useMenuItems = () => {
  const { permissions, hasPermission, user } = usePermissions();
  
  return {
    items: getFilteredMenuItems(permissions, hasPermission, user)
  };
};

// Default export for backward compatibility
const menuItems = {
  items: baseMenuItems
};

export default menuItems;
